// ** React Imports
import { Suspense } from 'react'

// ** Third Party Imports
import { Outlet } from 'react-router-dom'

// ** Widget Imports
import { Navbar } from '@/widgets/navbar'
import { NavbarNew } from '@/widgets/navbar-new'
// import { Footer } from '@/widgets/footer'

// ** Component Imports
import { FallbackLoader } from '@/shared/ui'

// ** Styled Components
import { LandingPageLayoutWrapper } from './styles'
import { FooterNew } from '@/widgets/footer-new'

export const LandingPageLayout = () => {
	return (
		<LandingPageLayoutWrapper>
			{/* <Navbar /> */}
			<NavbarNew />
			<Suspense fallback={<FallbackLoader />}>
				<Outlet />
			</Suspense>
			{/* <Footer /> */}
			<FooterNew />
		</LandingPageLayoutWrapper>
	)
}
